import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "fde1ba30-0be8-41d6-a9d0-d6bf078b5fa2",
  solutionType: "custom012100",
  type: "custom012100",
  options: {
    targetPointLocation: [4, 4],
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom012100",
  data: {
    indexes: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
  },
};
